import { CarbonInstance } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export type CarbonInstancesQuery = Partial<CarbonInstance> & {
  programMonitoringPeriodId?: string | string[]
  cumulative?: boolean
}

export default async function getCarbonInstances({
  farmId,
  query,
  signal,
}: {
  farmId: string
  query?: CarbonInstancesQuery
  signal?: AbortSignal
}): Promise<CarbonInstance[]> {
  const response = await apiClient.get(endpoints.carbonInstances, {
    params: { farmId, ...query },
    signal,
  })
  return unwrapCollection<CarbonInstance>(response)
}
